import { type RowInterface } from "./ocr.utils.types"

export const flattenOcrFormRows = (rows: Array<RowInterface>): Array<RowInterface> => {
    const acc: Array<RowInterface> = []
    for (const row of rows) {
        acc.push(row)
        if (row.children?.length) {
            acc.push(...row.children)
        }
    }
    return acc
}
